import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { App as CapacitorApp, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { Network } from '@capacitor/network';

import { networkStatus$ } from '@mopla/business-logic';

export function AppListener() {
	const navigate = useNavigate();
	const [platform] = useState(Capacitor.getPlatform());

	useEffect(() => {
		let listener: PluginListenerHandle | null = null;

		const setupListener = async () => {
			listener = await CapacitorApp.addListener(
				'appUrlOpen',
				(event: URLOpenListenerEvent) => {
					const url = new URL(event.url);
					if (url && url.pathname) {
						navigate(url.pathname + url.search);
					}
					// If no match, do nothing - let regular routing
					// logic take over
				}
			);
		};

		setupListener();

		return () => {
			if (listener) {
				listener.remove();
			}
		};
	}, []);

	useEffect(() => {
		let listener: PluginListenerHandle | null = null;

		const setupListener = async () => {
			listener = await Network.addListener('networkStatusChange', (status) => {
				networkStatus$.next(status.connected);
			});
		};

		setupListener();

		return () => {
			if (listener) {
				listener.remove();
			}
		};
	}, []);

	useEffect(() => {
		const listeners: PluginListenerHandle[] = [];

		const setupListeners = async () => {
			if (platform !== 'web') {
				const l1 = await Keyboard.addListener('keyboardWillHide', () => {
					document.body.style.removeProperty('--keyboard-height');
					document.body.classList.remove('keyboard-is-open');
				});
				const l2 = await Keyboard.addListener('keyboardWillShow', (info) => {
					document.body.classList.add('keyboard-is-open');
					document.body.style.setProperty(
						'--keyboard-height',
						info.keyboardHeight + 'px'
					);
				});
				const l3 = await Keyboard.addListener('keyboardDidShow', () => {
					document.activeElement?.scrollIntoView({ behavior: 'smooth' });
				});
				listeners.push(l1, l2, l3);
			}
		};

		setupListeners();

		return () => {
			listeners.forEach((l) => l.remove());
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (platform === 'android') {
			let backButtonListener: PluginListenerHandle | null = null;

			const setupListener = async () => {
				backButtonListener = await CapacitorApp.addListener(
					'backButton',
					({ canGoBack }) => {
						if (!canGoBack) {
							CapacitorApp.exitApp();
						} else {
							window.history.back();
						}
					}
				);
			};

			setupListener();

			return () => {
				if (backButtonListener) {
					backButtonListener.remove();
				}
			};
		} else {
			return;
		}
	}, [platform]);

	return null;
}
